// extracted by mini-css-extract-plugin
export default {"wrapper":"aWOdN","content":"fSwUY","device":"zn0Lv","title":"QraF5","text":"DCTcM"};